import {IntegrationTaskMap} from './integration-task-map.model';
import {DataAttribute} from './data-attribute.model';
import {RequestedAction} from '@app/core/model/integration-models';
import {DomainOfUniqueness} from './domain-of-uniqueness.model';
import {EntityFilterModel} from '@app/core/model/filtering/entity-filter-model';

export class IntegrationTask {

    /* static instanceOf(obj: any): IntegrationTask {
        return new IntegrationTask(
            obj.taskId,
            obj.integrationId,
            obj.sourceType,
            obj.targetType,
            obj.csvFileName,
            obj.mappings,
            obj.sourceAttributeList,
            obj.targetAttributeList
        );
    }*/

    public requestedAction: RequestedAction;
    public taskIndex: number;
    public transformations: EntityFilterModel[] = <EntityFilterModel[]>[];
    public validations: EntityFilterModel[] = <EntityFilterModel[]>[];
    public streamTransformations: EntityFilterModel[] = <EntityFilterModel[]>[];
    public domainsOfUniqueness: DomainOfUniqueness[] = <DomainOfUniqueness[]>[];
    public restrictedMappings: IntegrationTaskMap[] = <IntegrationTaskMap[]>[];

    constructor(
        public taskId: string = null,
        public integrationId: string = '',
        public sourceType: string = '',
        public targetType: string = '',
        public csvFileName: string = '',
        public mappings: IntegrationTaskMap[] = <IntegrationTaskMap[]>[],
        public sourceAttributeList: DataAttribute[] = <DataAttribute[]>[],
        public targetAttributeList: DataAttribute[] = <DataAttribute[]>[]
        // public filtrations: EntityFilterModel[] = <EntityFilterModel[]>[]
    ) { }
}

export const VALIDATIONS = 'validations';
export const FILTRATIONS = 'filtrations';
export const SSO_FILTRATIONS = 'sso';
export const TRANSFORMATIONS = 'transformations';
export const STREAM = 'stream';
export const STREAM_TRANSFORMATIONS = 'streamTransformations';
export const TRANSFORM = 'transform';
